import { useState, useEffect } from 'react';

const useFacebookSDK = (appId, language = "vi") => {
  const [loading, setLoading] = useState(true);
  const [available, setAvailable] = useState(true);
  useEffect(() => {
    var _a;
    if (typeof window === "undefined")
      return;
    if (typeof FB != "undefined" && ((_a = window == null ? void 0 : window.fbAsyncInit) == null ? void 0 : _a.hasRun)) {
      setAvailable(true);
      setLoading(false);
      return;
    }
    initializeFacebook(appId, language).catch(() => setAvailable(false)).then(() => {
    }).finally(() => setLoading(false));
  }, [appId, language]);
  const xfbmlParse = () => {
    if (typeof window === "undefined")
      return;
    if (window == null ? void 0 : window.FB) {
      window.FB.XFBML.parse();
    }
  };
  const fb = typeof window !== "undefined" ? window == null ? void 0 : window.FB : void 0;
  return { loading, available, fb, xfbmlParse };
};
const initializeFacebook = async (appId, language) => {
  return new Promise((resolve) => {
    (function(d, s, id) {
      var _a;
      if (d.getElementById(id)) {
        resolve(true);
      }
      const fjs = d.getElementsByTagName(s)[0];
      const js = d.createElement(s);
      js.id = id;
      js.async = true;
      js.src = `https://connect.facebook.net/${language === "en" ? "en_US" : "vi_VN"}/sdk.js#xfbml=1&version=v16.0&appId=${appId}&autoLogAppEvents=1&status=1&cookie=1`;
      js.defer = true;
      (_a = fjs.parentNode) == null ? void 0 : _a.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  });
};

export { useFacebookSDK };
